module.exports = __webpack_public_path__ + "static/temperature_final-44750575ac807c392c5b4b49475653fc.mp4";